import { useState } from 'react';
import { useConnect } from '@lore/query-connect';
import { parse } from 'query-string';
import moment from 'moment-timezone';
import useStewardshipFilter from '@/pages/evaluations-project-partners/useStewardshipFilter';
import getQueryUtils, { attributeKeys } from '@/pages/evaluations-project-partners/queryUtils';

export default function useQuery(props) {
  const {
    search = {},
    pageSize = 10,
    schoolStart,
    schoolEnd
  } = props;

  const [timestamp] = useState(moment().toISOString());
  const stewardshipFilter = useStewardshipFilter();

  const queryUtils = getQueryUtils(search, attributeKeys, timestamp);

  return useConnect('evaluationProjectPartner.find', {
    where: {
      eager: {
        $where: {
          $and: [...queryUtils.where],
          completed: false,
          status: { $ne: 'abandoned' },
          $or: stewardshipFilter,
          createdAt: {
            $lte: schoolEnd,
            $gte: schoolStart
          }
        }
      }
    },
    pagination: {
      page: parse(location.search).page || '1',
      pageSize: pageSize,
      order: search.order || 'createdAt desc'
    }
  }, {
    keepPreviousData : true
  });
}
